import script from "./skills.vue?vue&type=script&setup=true&lang=js"
export * from "./skills.vue?vue&type=script&setup=true&lang=js"

import "./skills.vue?vue&type=style&index=0&id=7ee72b27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee72b27"]])

export default __exports__